<template>
  <v-dialog v-model="localShow" max-width="500">
    <v-card>
      <v-card-title :class="isEditing ? 'bg-primary' : 'bg-success'" class="text-white">
        <v-icon class="mr-2">{{ isEditing ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
        {{ isEditing ? 'Edit MVNO API Method' : 'Add MVNO API Method' }}
      </v-card-title>
      <v-card-text class="pt-4">
        <v-form ref="form">
          <v-text-field
            v-model="localForm.name"
            label="Method Name (key) *"
            :rules="[v => !!v || 'Name is required']"
            outlined
            dense
            hint="Internal method name (e.g. provision_sim, add_subscription)"
            persistent-hint
          ></v-text-field>

          <v-text-field
            v-model="localForm.description"
            label="Description"
            outlined
            dense
            hint="Display description (e.g. Provision SIM (New Subscriber))"
            persistent-hint
            class="mt-2"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">
          {{ isEditing ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MvnoApiMethodDialog',
  props: {
    show: { type: Boolean, default: false },
    isEditing: { type: Boolean, default: false },
    formData: { type: Object, default: () => ({}) },
    saving: { type: Boolean, default: false }
  },
  emits: ['close', 'save'],
  data() {
    return {
      localForm: {
        id: null,
        name: '',
        description: ''
      }
    }
  },
  computed: {
    localShow: {
      get() { return this.show },
      set(val) { if (!val) this.$emit('close') }
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.localForm = {
          id: this.formData.id || null,
          name: this.formData.name || '',
          description: this.formData.description || ''
        }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      if (!this.localForm.name) return
      this.$emit('save', { ...this.localForm })
    }
  }
}
</script>
